import store from '@/store'

import dashboard from './routesConfig/dashboard'
import appMana from './routesConfig/appMana'
import userMana from './routesConfig/userMana'
import ShopMana from './routesConfig/shopMana'
import industryMana from './routesConfig/industryMana'
import DeviceMana from './routesConfig/deviceMana'
import idInfoMana from './routesConfig/idInfoMana'

import defaultRoutes from './routesConfig/deafult'
export const routesConfig = [dashboard, appMana, industryMana, ShopMana, idInfoMana, DeviceMana, userMana]

export const routesMap = createRoutesMap(routesConfig)

function createRoutesMap(routes) {
  let mapData = {}
  routes.forEach(route => {
    const { name, redirect } = route
    // redirect存在时，这是一个重定向路由，略过
    if (name && !redirect) {
      mapData[route.name] = { name: route.meta.title }
      // 有 children 说明当前路由是个中间路由，不导航至实际页面，所以不记录其 path
      // 无 children 说明当前路由导航至实际页面，则记录其 path
      if (route.children) {
        mapData = Object.assign(mapData, createRoutesMap(route.children))
      } else {
        mapData[route.name].path = route.path
      }
    }
  })
  return mapData
}
export default () => {
  const routes = [].concat(defaultRoutes)
  // 获取登录用户页面权限数组
  const { userInfo } = store.state.userStore
  if (userInfo) {
    let authPages = userInfo.userAuthIds

    authPages = supplementUpperPage(authPages)

    const addRoute = {
      path: '/',
      component: () =>
        import(/* webpackChunkName: 'basicLayout' */ '@/layouts/BasicLayout'),
      children: [
        // { path: '', redirect: '/dashboard' },
        // dashboard,
        ...routesFilter(authPages, routesConfig)
      ]
    }
    const firstPath = addRoute.children[0].path
    addRoute.children.unshift({ path: '', redirect: firstPath })

    routes.splice(1, 0, addRoute)
    routes.push({
      path: '/*',
      redirect: '/404'
    })

    // Vuex 设置登录用户的页面路由
    store.commit('setUserRoutes', routes)
  }
  return routes
}

function routesFilter(userAuths, routes) {
  let newRoutes = []
  routes.forEach(route => {
    const { name, redirect } = route
    let newRoute = null

    if (userAuths.indexOf('all') !== -1 || userAuths.indexOf(name) !== -1 || redirect) {
      newRoute = route
      if (newRoute.children) {
        let children = []
        children = routesFilter(userAuths, newRoute.children)
        children = children.filter(r => r)

        if (children.length) {
          newRoute.children = children
        } else {
          delete newRoute.children
        }
      }
    }
    newRoutes.push(newRoute)
  })

  newRoutes = newRoutes.filter(r => r)
  return newRoutes
}

// 补充授权页面的上级
// ['Platform.UserGroup'] --> ['Platform', 'Platform.UserGroup']
export function supplementUpperPage(authPages) {
  let newAuthPages = []
  authPages.forEach(name => {
    const splitArr = name.split('.')
    let newName = ''
    splitArr.forEach(name => {
      newName = newName ? `${newName}.${name}` : name
      newAuthPages.push(newName)
    })
  })
  newAuthPages = Array.from(new Set(newAuthPages))
  return newAuthPages
}
